@let isSm = viewportSelectors.isSm | select;
<div class="flex flex-col items-center">
  @if (isSm) {
    <img ngSrc="/assets/registration/lookup-account-sm.png" priority width="300" height="200" alt=""
         class="w-[18.75rem] h-[12.5rem] mb-6"/>
  }
  <mat-card class="max-w-[25rem]">
    <mat-card-content class="flex flex-col gap-y-3">
      <div class="text-headline-large">Look Up Account</div>
      <div class="text-body-large mb-8">Enter your library card number and PIN to find your account and complete the
        online registration.
      </div>
      <mx-input-form-field fieldName="cardNumber" overrideLabel="Library Card Number" [formGroup]="lookupForm"/>
      <mx-input-form-field fieldName="pin" overrideLabel="PIN" [formGroup]="lookupForm"/>
      <mx-filled-button label="Look Up Account" [enabled]="lookupForm.valid" (click)="onClickNext()" class="my-4"/>
      <div class="text-body-large self-center">
        Don’t have a library card? <a class="text-title-medium pl-2" pxNamedRouterLink="REGISTER">Sign up here</a>
      </div>
    </mat-card-content>
  </mat-card>
</div>
<div class="max-w-[50%] overflow-hidden ml-4">
  @if (!isSm) {
    <img ngSrc="/assets/registration/lookup-account.png" priority width="472" height="540" alt=""
         class="max-w-[20rem] lg:max-w-[29.5rem]"/>
  }
</div>
